import isEqual from 'lodash-es/isEqual'
import omit from 'lodash-es/omit'
import * as Yup from 'yup'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
  isRemoveAllEntityActionType,
} from '../../Entity'
import { formValidationSchemaNoChanged } from '../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../Formik'

import {
  REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT,
  REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_TEMPLATE,
  REQUEST_EDIT_USER_COMMENT_FIELDS_INITIAL_VALUE,
} from './RequestEditUserCommentFields'
import { REQUEST_EDIT_USER_FIELDS_FIELD_NAME_IS_COMMENT } from './RequestEditUserModalFields'

function isRequestEditUserModalFormFieldsEqual({
  initialValues,
  userFieldName,
  values,
}) {
  const exceptCommentFields = !values[
    REQUEST_EDIT_USER_FIELDS_FIELD_NAME_IS_COMMENT
  ]
    ? [REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT]
    : EMPTY_LIST

  const exceptFields = [
    userFieldName,
    REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_TEMPLATE,
    ...exceptCommentFields,
  ]

  const isAllEqualExceptUsers = isEqual(
    omit(initialValues, exceptFields),
    omit(values, exceptFields)
  )

  const isEqualUsers = isEqual(
    initialValues[userFieldName].map(item => item.id).sort(),
    values[userFieldName].map(item => item.id || item.value).sort()
  )

  return isAllEqualExceptUsers && isEqualUsers
}

export function getRequestEditUserModalValidationSchema({
  initialValues,
  itemAction,
  userFieldName,
}) {
  return Yup.object({
    [userFieldName]: Yup.array().when(
      FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME,
      {
        is: actionType => !isRemoveAllEntityActionType(actionType),
        then: schema => schema.of(Yup.object()).min(1, true),
      }
    ),
  }).when(EMPTY_LIST, {
    is: () => itemAction,
    then: schema =>
      schema.concat(
        formValidationSchemaNoChanged({
          initialValues,
          isEqual: isRequestEditUserModalFormFieldsEqual,
          isEqualProps: {
            userFieldName,
          },
        })
      ),
  })
}

export function getRequestEditUserModalEmptyValues(userFieldName) {
  return { [userFieldName]: EMPTY_LIST }
}

export function getRequestEditUserModalInitialValue({
  itemAction,
  userFieldName,
  users,
} = EMPTY_OBJECT) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...REQUEST_EDIT_USER_COMMENT_FIELDS_INITIAL_VALUE,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]: itemAction
      ? actionTypeOptions[EntityActionTypeSelectOptionValue.Edit]
      : actionTypeOptions[EntityActionTypeSelectOptionValue.Add],
    [REQUEST_EDIT_USER_FIELDS_FIELD_NAME_IS_COMMENT]: false,
    [userFieldName]: users || EMPTY_LIST,
  }
}

export function getRequestEditUserModalPayload({
  payloadParamKey,
  userFieldName,
  values,
}) {
  const payload = {
    [payloadParamKey || userFieldName]: values[userFieldName].map(
      item => item.value || item.id
    ),
  }

  if (values[REQUEST_EDIT_USER_FIELDS_FIELD_NAME_IS_COMMENT]) {
    payload[REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT] =
      values[REQUEST_EDIT_USER_COMMENT_FIELDS_FIELD_NAME_COMMENT]
  }

  return payload
}
